const AGENTS = {
    WEB_VIEW: "webview",
    // Everything else
};

export default AGENTS;
